function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef, useEffect } from "react";
import useRewardTags from "../../../../Hooks/use-rewardTags";
import AiOutlineDown from "@meronex/icons/ai/AiOutlineDown";
import AiOutlineUp from "@meronex/icons/ai/AiOutlineUp";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var CategoryDropdown = function CategoryDropdown(_ref) {
  var category = _ref.category,
    isSelected = _ref.isSelected,
    onCategoryClick = _ref.onCategoryClick,
    onTagClick = _ref.onTagClick,
    selectedTag = _ref.selectedTag,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState("bottom"),
    _useState4 = _slicedToArray(_useState3, 2),
    dropdownPosition = _useState4[0],
    setDropdownPosition = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    dropdownStyle = _useState6[0],
    setDropdownStyle = _useState6[1];
  var dropdownRef = useRef(null);
  var buttonRef = useRef(null);
  var _useRewardTags = useRewardTags({
      categoryId: category.id,
      redux: redux,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    tags = _useRewardTags.tags,
    isLoading = _useRewardTags.isLoading;

  // Calculate dropdown position
  var calculateDropdownPosition = function calculateDropdownPosition() {
    if (buttonRef.current) {
      var buttonRect = buttonRef.current.getBoundingClientRect();
      var spaceBelow = window.innerHeight - buttonRect.bottom;
      var spaceAbove = buttonRect.top;
      var isTop = spaceBelow < 200 && spaceAbove > spaceBelow;
      setDropdownPosition(isTop ? "top" : "bottom");
      setDropdownStyle({
        zIndex: 999999,
        left: buttonRect.left,
        top: isTop ? buttonRect.top - 8 : buttonRect.bottom + 8,
        transform: isTop ? "translateY(-100%)" : "none"
      });
    }
  };

  // Close dropdown when clicking outside and handle positioning
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    var handleScroll = function handleScroll() {
      if (isOpen) {
        calculateDropdownPosition();
      }
    };
    var handleResize = function handleResize() {
      if (isOpen) {
        calculateDropdownPosition();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true);
    window.addEventListener("resize", handleResize);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
      window.removeEventListener("resize", handleResize);
    };
  }, [isOpen]);
  var handleCategoryClick = function handleCategoryClick(e) {
    e.stopPropagation();
    if (isLoading) {
      // Don't do anything while loading
      return;
    }
    if (tags.length > 0) {
      if (!isOpen) {
        calculateDropdownPosition();
      }
      setIsOpen(!isOpen);
    } else {
      // If no tags, behave like current implementation
      onCategoryClick(category.id);
    }
  };
  var handleTagClick = function handleTagClick(e, tag) {
    e.stopPropagation();
    onTagClick(tag.id, category.id);
    setIsOpen(false);
  };
  var isTagSelected = function isTagSelected(tagId) {
    return (selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.tagId) === tagId && (selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.categoryId) === category.id;
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "relative",
    ref: dropdownRef,
    children: [/*#__PURE__*/_jsxs("button", {
      ref: buttonRef,
      onClick: handleCategoryClick,
      className: "flex items-center gap-2 px-4 py-2 rounded-3xl border border-grey-200 text-sm font-semibold transition-colors\n                    ".concat(isSelected ? "bg-primary text-white" : "bg-white text-gray-700 hover:bg-gray-50", "\n                    ").concat(tags.length > 0 ? "cursor-pointer" : "cursor-pointer", "\n                "),
      children: [/*#__PURE__*/_jsx("span", {
        children: category.name
      }), isLoading ? /*#__PURE__*/_jsx("div", {
        className: "w-4 h-4 border-2 border-gray-300 border-t-primary rounded-full animate-spin"
      }) : tags.length > 0 ? /*#__PURE__*/_jsx(_Fragment, {
        children: isOpen ? /*#__PURE__*/_jsx(AiOutlineUp, {
          className: "w-4 h-4"
        }) : /*#__PURE__*/_jsx(AiOutlineDown, {
          className: "w-4 h-4"
        })
      }) : null]
    }), isOpen && /*#__PURE__*/_jsx("div", {
      ref: dropdownRef,
      className: "fixed w-48 bg-white border border-gray-200 rounded-lg shadow-xl py-1 max-h-60 overflow-y-auto",
      style: dropdownStyle,
      children: isLoading ? /*#__PURE__*/_jsxs("div", {
        className: "px-4 py-2 text-sm text-gray-500 flex items-center gap-2",
        children: [/*#__PURE__*/_jsx("div", {
          className: "w-4 h-4 border-2 border-gray-300 border-t-primary rounded-full animate-spin"
        }), "Loading tags..."]
      }) : tags.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("button", {
          onClick: function onClick(e) {
            e.stopPropagation();
            onCategoryClick(category.id);
            setIsOpen(false);
          },
          className: "w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition-colors\n                                    ".concat(isSelected && !selectedTag ? "bg-primary text-white" : "text-gray-700", "\n                                "),
          children: ["All ", category.name]
        }), /*#__PURE__*/_jsx("hr", {
          className: "my-1 border-gray-200"
        }), tags.map(function (tag) {
          return /*#__PURE__*/_jsx("button", {
            onClick: function onClick(e) {
              return handleTagClick(e, tag);
            },
            className: "w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition-colors\n                                        ".concat(isTagSelected(tag.id) ? "bg-primary text-white" : "text-gray-700", "\n                                    "),
            children: tag.name
          }, tag.id);
        })]
      }) : /*#__PURE__*/_jsx("div", {
        className: "px-4 py-2 text-sm text-gray-500",
        children: "No tags available"
      })
    })]
  });
};
export default CategoryDropdown;